import { render, staticRenderFns } from "./LogicArgs.vue?vue&type=template&id=6932b6fa&scoped=true"
import script from "./LogicArgs.vue?vue&type=script&lang=js"
export * from "./LogicArgs.vue?vue&type=script&lang=js"
import style0 from "./LogicArgs.vue?vue&type=style&index=0&id=6932b6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6932b6fa",
  null
  
)

export default component.exports